import { useState, useEffect } from 'react';
import { getToken } from '../../config/firebase';
import { usePostgresUser } from '../../components/utils/PostgresUserContext';
import { backendService } from '../api/backendService';

export const useMaxLevel = () => {
  const { user, loading: authLoading } = usePostgresUser();
  const [maxLevel, setMaxLevel] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!authLoading) {
      fetchMaxLevel();
    }
  }, [authLoading, user]);

  const getIdToken = () => {
    return getToken(); // Returns null if not logged in (public access OK)
  };

  const fetchMaxLevel = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const idToken = await getIdToken();
      const data = await backendService.getMaxLevel(idToken);
      setMaxLevel(data.maxLevel);
    } catch (err) {
      console.error('Error fetching max level:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { maxLevel, isLoading, error };
};